import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const logoutRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const checkoutUrlData = localStorage.getItem('checkout-url');

  if (checkoutUrlData) {
    const checkoutUrl = JSON.parse(checkoutUrlData) as {
      path: string;
      token: string | null;
    };
    localStorage.removeItem('checkout-url');
    void router.navigate([checkoutUrl.path], {
      queryParams: checkoutUrl.token ? { token: checkoutUrl.token } : {},
      queryParamsHandling: 'merge',
    });
  } else {
    void router.navigate(['/seat-selection']);
  }

  return false;
};
